import { useEffect, useState } from 'react';

import { usePrev } from './usePrev';
import { isSame } from '@umu/umu-util';
import { IOption } from '@umu/umu-fetch';
import { ERROR_CODE, IResponse } from '@umu/umu-types';

export type IFetch = (data: any, option?: IOption) => Promise<IResponse<any>>;
export type IFetcher = <R>(data: any, option?: IOption) => Promise<IResponse<R>>;

export interface IResult<T> {
    data: T | null;
    error_code: ERROR_CODE | null;
}

/**
 * fetch 方便把请求从业务代码里抽离出来
 * @param fetcher {Promise} 方法函数
 * @param params {any} 参数
 * @param condition {boolean} 调用条件控制，用来控制 fetch 的时机
 * @param deps dependency list
 * @param option fetchData 的第三个参数
 * @returns {data: T | null, error_code: ERROR_CODE | null}
 * @author Kody
 */

export function useFetch<R>(fetcher: IFetch, params: any = null, condition = true, deps: any[] = [], option?: IOption) {
    const preParams = usePrev(params);
    const [res, setRes] = useState<IResult<R>>({ data: null, error_code: null });

    useEffect(() => {
        if (condition && !isSame(params, preParams)) {
            (fetcher as IFetcher)<R>(params, option).then(
                (result: IResponse<R>) => {
                    setRes({ data: result.data, error_code: result.error_code });
                },
                () => {
                    setRes({ data: null, error_code: 1 });
                }
            );
        }
    }, [...deps, params, condition]);
    return res;
}
